<ng-template [ngIf]="link.startsWith('/entities/') && target != '_blank'" [ngIfElse]="defaultExternal">
    <a routerLink="{{link}}" [title]="getText()">
        <cbic-static-text [textEn] = "linkTextEn" [textHi] = "linkTextHi"></cbic-static-text>
        <i *ngIf="iconClass" class="{{iconClass}}" aria-hidden="true"></i>
    </a>
</ng-template>
<ng-template #defaultExternal>
    <a href="{{link}}" target="_blank" [title]="getText()">
        <cbic-static-text [textEn] = "linkTextEn" [textHi] = "linkTextHi"></cbic-static-text>
        <i *ngIf="iconClass" class="{{iconClass}}" aria-hidden="true"></i>
    </a>
</ng-template>
<ng-content></ng-content>